import URI from 'urijs'
import {DateFormat} from '../date_format'
import {EnterTT} from '../constants'

export function makeEnterTTUrl(date, userId) {
    const url = URI(EnterTT.PAGE_URL)
    date && url.addSearch("date", new DateFormat("yyyy-MM-dd").formatDate(date))
    userId && url.addSearch("cuser", userId)
    return url.toString()
}

export default {
    makeEnterTTUrl
}



// WEBPACK FOOTER //
// ./web/js/util/EnterTTUrlUtils.js